import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle, FiStar, FiArrowRight, FiShield, FiMessageCircle } = FiIcons;

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} className="relative">
              <div className="relative aspect-[959/1280] w-full max-w-md mx-auto lg:mx-0">
                <div className="absolute inset-0 bg-blue-600 rounded-[40px] rotate-3 opacity-10"></div>
                <img src="https://i.imgur.com/9ca0n4G.png" alt="Dra. Luene Gomes UniPET Juiz de Fora" className="relative w-full h-full object-cover rounded-[40px] shadow-2xl border-8 border-white" />
                <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-3xl shadow-xl border border-gray-100">
                  <p className="text-blue-600 font-bold text-lg">Dra. Luene Gomes</p>
                  <p className="text-gray-500 text-sm font-bold uppercase tracking-widest">CRMV-MG 29719</p>
                </div>
              </div>
            </motion.div>

            <div className="space-y-8">
              <div>
                <span className="text-blue-600 font-extrabold tracking-widest uppercase text-sm mb-4 block">Autoridade em Juiz de Fora</span>
                <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
                  Por que a UniPET é a referência em Estética Animal em JF?
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-6 font-medium">
                  Fundada pela <b>Dra. Luene Gomes</b>, a UniPET nasceu para elevar o padrão de estética animal no Centro de JF. Combinamos o cuidado clínico com o amor pelos animais, garantindo que cada pet receba um tratamento individualizado e seguro.
                </p>
              </div>

              <div className="space-y-6 bg-blue-50/50 p-8 rounded-[32px] border border-blue-100">
                <div>
                  <h3 className="text-xl font-extrabold text-blue-900 mb-2">Monitoramento Veterinário</h3>
                  <p className="text-gray-700 leading-relaxed font-medium">
                    Diferente de petshops comuns, aqui cada procedimento é acompanhado por olhar técnico, prevenindo problemas de pele e garantindo o bem-estar durante todo o banho.
                  </p>
                </div>
              </div>

              <div className="pt-4">
                <a href="https://wa.me/5532999857587" target="_blank" rel="noopener noreferrer" className="bg-blue-900 text-white px-8 py-4 rounded-xl font-bold hover:bg-blue-950 transition-all flex items-center gap-2 shadow-lg shadow-blue-900/20">
                  Falar com especialista no WhatsApp <SafeIcon icon={FiMessageCircle} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;